import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Api from '../Api.js';
export default function Accept() {
    const location = useLocation()
    const navigate = useNavigate()
    const { id } = useParams();
    const [status,setStatus] = useState("in_progress")
    useEffect(() => {
        (async () => {
            try {
                if (id && location.search) {
                    const { data } = await Api.validateAcceptAgentTask(location.search + `&task_id=${id}`)
                    if (data.ok) {
                        await Api.acceptAgentTask({
                            task_id: id,
                            token: location.search.replace("?token=",""),
                            status,
                        })
                        navigate(`/main_employee/agent-task/${id}`)
                    }
                }
            } catch (error) {
                navigate(`/employee`)
                localStorage.setItem("in_prog",location.search + `&task_id=${id}`)
                console.log(error);
                
            }
        })()
    }, [location.search, id])



    return (
        <div>Հաստատման փուլ</div>
    )
}
